import React from "react";
import { Helmet } from "react-helmet-async";

export default function InsurancePage() {
  return (
    <div className="w-full min-h-screen bg-gray-100 p-4">
      {/* Life Insurance Section */}
       <Helmet>
              <title>Kota HOLDINGS</title>
              <meta name="description" content="A Vision of My 30-Year World" />
            </Helmet>
      
      {/* Health Insurance Section */}
      <div className=" mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-8">
        <div className="bg-[#FF6F00] text-white p-6">
          <h2 className="text-2xl font-bold">We provide the best value Health Insurance</h2>
          <p className="mt-2">Simple steps you can take to secure your health and well-being.</p>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
            <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
            <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
          </div>
          <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
          <button className="mt-4 bg-blue-500 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Get Quote</button>
        </div>
        <div className="p-6">
          <h3 className="text-xl font-bold">What is Health Insurance?</h3>
          <p className="mt-2">Health insurance is a financial protection plan that covers medical expenses...</p>
          <ul className="list-disc ml-6 mt-2">
            <li><b>Indemnity Plan:</b> Choose your healthcare providers with flexible coverage.</li>
            <li><b>Fixed Benefit Plan:</b> Predefined payouts for specific medical events.</li>
          </ul>
        </div>
        <div className="p-6 bg-gray-50">
          <h3 className="text-xl font-bold">Why Choose Our Health Insurance?</h3>
          <ul className="list-disc ml-6 mt-2">
            <li>24x7 Support</li>
            <li>Easy Claim System</li>
            <li>Affordable Premiums</li>
            <li>Strong Security & Protection</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
